// extracted by mini-css-extract-plugin
export default {"whatsapp_icon":"WhatsApp_whatsapp_icon__2Fnj+"};